// extracted by mini-css-extract-plugin
module.exports = {"hero":"VideoHero_hero__9t5Ua","content":"VideoHero_content__CIoVy","date":"VideoHero_date__hqdvI","cta":"VideoHero_cta__iET1W","backgroundVideo":"VideoHero_backgroundVideo__cbHix"};